import {generateThemes, lighten, translucify} from '@nfq/colors';

import type {GetThemeType} from '@nfq/colors';

export const BaseColors = {
    /** Error color. ![#DF162E](https://dummyimage.com/12/DF162E/DF162E.png) `#DF162E`. */
    error: '#DF162E',
    /** Neutral color 0. ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    neutral0: '#FFFFFF',
    /** Neutral color 20. ![#F3F3F5](https://dummyimage.com/12/F3F3F5/F3F3F5.png) `#F3F3F5`. */
    neutral20: '#F3F3F5',
    /** Neutral color 40. ![#B4B4BE](https://dummyimage.com/12/B4B4BE/B4B4BE.png) `#B4B4BE`. */
    neutral40: '#B4B4BE',
    /** Neutral color 60. ![#73737D](https://dummyimage.com/12/73737D/73737D.png) `#73737D`. */
    neutral60: '#73737D',
    /** Neutral color 80. ![#3C3C46](https://dummyimage.com/12/3C3C46/3C3C46.png) `#3C3C46`. */
    neutral80: '#3C3C46',
    /** Neutral color 100. ![#00001E](https://dummyimage.com/12/00001E/00001E.png) `#00001E`. */
    neutral100: '#00001E',
    /** Primary color. ![#0050FF](https://dummyimage.com/12/0050FF/0050FF.png) `#0050FF`. */
    primary: '#0050FF',
    /** Darker shade of primary. ![#00008C](https://dummyimage.com/12/00008C/00008C.png) `#00008C`. */
    primaryDark: '#00008C',
    /** Lighter shade of primary. ![#82DCFA](https://dummyimage.com/12/82DCFA/82DCFA.png) `#82DCFA`. */
    primaryLight: '#82DCFA ',
    /** First secondary color. ![#FFA55A](https://dummyimage.com/12/FFA55A/FFA55A.png) `#FFA55A`. */
    secondary1: '#FFA55A',
    /** Second secondary color. ![#F65D7C](https://dummyimage.com/12/F65D7C/F65D7C.png) `#F65D7C`. */
    secondary2: '#F65D7C',
    /** Third secondary color. ![#00DC7D](https://dummyimage.com/12/00DC7D/00DC7D.png) `#00DC7D`. */
    secondary3: '#00DC7D',
    /** Fourth secondary color. ![#A078FF](https://dummyimage.com/12/A078FF/A078FF.png) `#A078FF`. */
    secondary4: '#A078FF',
    /** Primary text color. ![#00001E](https://dummyimage.com/12/00001E/00001E.png) `#00001E`. */
    textPrimary: '#00001E',
    /** Inverse primary text color. ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    textPrimaryInv: '#FFFFFF',
    /** Secondary text color. ![#73737D](https://dummyimage.com/12/73737D/73737D.png) `#73737D`. */
    textSecondary: '#73737D',
    /** Inverse secondary text color. ![#F3F5F6](https://dummyimage.com/12/F3F5F6/F3F5F6.png) `#F3F5F6`. */
    textSecondaryInv: '#F3F5F6'
} as const;

export const DerivedColors = {
    buttonPrimaryLightHover: lighten(BaseColors.primary, 20),
    buttonSecondaryDarkHover: translucify(BaseColors.neutral0, 10)
} as const;

export const BoxShadows = {
    buttonShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.25)',
    lg: '0 12px 16px -4px rgba(1, 0, 33, 0.08), 0 4px 6px -2px rgba(1, 0, 33, 0.03)',
    md: '0 4px 8px -2px rgba(1, 0, 33, 0.10), 0 2px 4px -2px rgba(1, 0, 33, 0.06)',
    menuShadow: '-3px 0px 12px -2px rgba(0, 0, 0, 0.19)',
    /** The default dropshadow for Popovers. */
    popOverShadow: '0px 0px 10px 5px rgba(25, 38, 48, 0.05)',
    sm: '0 1px 3px 0 rgba(1, 0, 33, 0.10), 0 1px 2px 0 rgba(1, 0, 33, 0.06)',
    xl: '0 20px 24px -4px rgba(1, 0, 33, 0.08), 0 8px 8px -4px rgba(1, 0, 33, 0.03)',
    xs: '0 1px 2px 0 rgba(1, 0, 33, 0.05)'
} as const;

export type BaseColorsType = GetThemeType<typeof BaseColors>;
export const {
    globalCss,
    shadows,
    themeColors,
    themes
} = generateThemes({
    baseColors: BaseColors,
    derivedColors: DerivedColors,
    shadows: BoxShadows
});